<script lang="ts" setup>
import { AppTypography } from '@/components/base';
import { useRuntimeConfig } from 'nuxt/app';

// The logo assets are full lockups — the "VoteWise" wordmark is part of the
// artwork — so `showLabel` defaults off; rendering the AppTypography label too
// would duplicate the name. The mark-only variant (the mobile subpage header)
// still passes `showLabel` explicitly alongside its own square `src`.
const {
  width = '169px',
  height = '40px',
  showLabel = false,
  src = '/logo-desktop.svg',
} = defineProps<{
  width?: string;
  height?: string;
  showLabel?: boolean;
  src?: string;
}>();

const config = useRuntimeConfig();
</script>

<template>
  <div class="app-logo">
    <NuxtLink
      to="/"
      class="app-logo__img flex items-center no-underline"
      aria-label="Home"
    >
      <img
        :src="src"
        :alt="config.public.appName"
        :width="width"
        :height="height"
        :class="{ 'mr-4': showLabel }"
        data-testid="logo"
      />
      <AppTypography
        v-if="showLabel"
        element="span"
        type="title-6"
        data-testid="app-name"
      >
        {{ config.public.appName }}
      </AppTypography>
    </NuxtLink>
  </div>
</template>

<style lang="scss" scoped>
.app-logo {
  &__img {
    background-color: transparent;
  }
}
</style>
